/**
 * This changes the appends/updates zip in the window.location.search
 * @param zipValue
 * @returns {string}
 * @private
 */
function _parseSearchWithZip(zipValue) {
    var newSearches = [];
    var hasZipParam = false;
    if(window.location.search) {
        var searches = window.location.search.substr(1, window.location.search.length);
        searches.split('&').forEach(function(search) {
            var searchSplit = search.split('=');
            var key = searchSplit[0];
            var value = searchSplit[1] || '';
            if(key === 'zip') {
                value = zipValue;
                hasZipParam = true;
            }
            newSearches.push(key+ '=' +value);
        });
    }
    if(!hasZipParam) {
        newSearches.push('zip='+zipValue);
    }

    return '?' + newSearches.join('&');
}

module.exports = {
    parseSearchWithZip: _parseSearchWithZip
};


//////////////////
// WEBPACK FOOTER
// ./src/interlock/ui/zipcode-changer/zipcode-changer-utils.js
// module id = 140
// module chunks = 0 1 16 24 25